import React, { ReactNode, useContext, useEffect } from 'react';

import { Box } from '@mui/material';

import Spinner from '~/components/Common/Spinner';

import useCurrentUser from '~/hooks/useCurrentUser';

import { AuthContext } from './AuthRouter';

type Props = {
  children?: ReactNode;
};

export default function HomeRoute({ children }: Props) {
  const { loading, authenticated, user } = useContext(AuthContext);

  const { setCurrentUserState } = useCurrentUser();

  useEffect(() => {
    setCurrentUserState({ isLoading: loading, isAuthenticated: authenticated, user: user ?? null });
  }, [loading, authenticated, user, setCurrentUserState]);

  if (loading) {
    return (
      <Box height="100vh" data-testid="auth-loading-spinner">
        <Spinner />
      </Box>
    );
  }

  return <>{children}</>;
}
